<div class="w-full mb-4 flex flex-wrap items-center justify-between pl-6 border-l-2 border-zinc-900 gap-4">
  <h2 class="text-lg font-semibold text-zinc-800">{{ title() }}</h2>
  <ng-content />
</div>
